// Sin esto la lupa sigue siendo un enlace a la pagina de busqueda, que es su
// href de verdad. Por delegacion, que el personalizador redibuja el encabezado.
(function () {
  var ABIERTA = 'gpets-search--open';

  function caja(el) {
    return el && el.closest ? el.closest('[data-gpets-search]') : null;
  }

  function abrir(c, si) {
    c.classList.toggle(ABIERTA, si);
    var lupa = c.querySelector('[data-gpets-search-toggle]');
    if (lupa) lupa.setAttribute('aria-expanded', si ? 'true' : 'false');
    if (si) {
      var campo = c.querySelector('input[type="search"]');
      if (campo) campo.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var lupa = e.target.closest ? e.target.closest('[data-gpets-search-toggle]') : null;
    if (lupa) {
      var c = caja(lupa);
      if (!c) return;
      e.preventDefault();
      abrir(c, !c.classList.contains(ABIERTA));
      return;
    }
    // Salvo dentro de ella: el desplegable de resultados vive ahi y elegir un
    // producto la habria cerrado antes de navegar.
    document.querySelectorAll('[data-gpets-search].' + ABIERTA).forEach(function (c) {
      if (!c.contains(e.target)) abrir(c, false);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-gpets-search].' + ABIERTA).forEach(function (c) {
      abrir(c, false);
      var lupa = c.querySelector('[data-gpets-search-toggle]');
      if (lupa) lupa.focus();
    });
  });
})();
